import React from 'react';

export default function Index() {
  return (
    <section>
      <h1 className="mb-3">Billing</h1>

      <p>
        Go ahead and fill out the billing details below, so we can wrap this up!
      </p>
    </section>
  );
}
